import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/** Quantity stepper: − / value / + (28px circular icon buttons). */
@Component({
  selector: 'app-quantity-stepper',
  templateUrl: './quantity-stepper.component.html',
  styleUrls: ['./quantity-stepper.component.scss'],
  standalone: true,
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuantityStepperComponent {
  @Input() quantity: number = 0;
  @Output() decrement = new EventEmitter<void>();
  @Output() increment = new EventEmitter<void>();

  // Stop the click so a clickable parent card isn't activated too
  onDecrement(event: Event): void {
    event.stopPropagation();
    this.decrement.emit();
  }

  onIncrement(event: Event): void {
    event.stopPropagation();
    this.increment.emit();
  }
}
